/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VirtualMachineAgent {
    getFixupPrototypeFunction() { return VirtualMachineAgent.fixupPrototype; }

    static newInstance(model: Partial<VirtualMachineAgent>): VirtualMachineAgent {
        let obj = Object.assign(new VirtualMachineAgent(), model);
        VirtualMachineAgent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VirtualMachineAgent>): VirtualMachineAgent {
        if (!model) return null;
        return VirtualMachineAgent.newInstance(<VirtualMachineAgent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VirtualMachineAgent) {
        if (!obj) return;

        models.VirtualMachineAgent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VirtualMachineAgent): boolean {
        Object.setPrototypeOf(obj, VirtualMachineAgent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Type of the agents used.
     */
    name: models.VirtualMachineAgentsType;

    /**
     * Installation status of the VM Agent
     */
    is_installed: boolean;

}
